import React from 'react'
import { ReactComponent as ScriptEmptyIcon } from '../modules/Dashboard/components/Empty/images/icon (10).svg'
import { ReactComponent as ScriptShareEmptyIcon } from '../modules/Dashboard/components/Empty/images/icon-container-basic.svg'
import { ReactComponent as EditIcon } from '../assets/images/editicon.svg'
import { ReactComponent as BreakDown } from '../assets/images/breakdown.svg'
import { ReactComponent as DeleteIcon } from '../assets/images/DeleteIcon.svg'
import { ReactComponent as RenameIcon } from '../assets/images/Rename.svg'
import { ReactComponent as TitleSheetIcon } from '../assets/images/titleSheet.svg'
import { ReactComponent as HistoryIcon } from '../assets/images/History.svg'
import { ReactComponent as CommentsIcons } from '../assets/icons/comments.svg'
// import Sora2 from '../assets/images/sora-2.png'
// import AnnapolisLogo from '../assets/images/annapolis-logo.png'
import MaterialIcon from '../components/core/MaterialIcon'

const BannerItems = [
  /* {
    icon: <RedeemIcon />,
    title: 'Featured On ProductHunt',
    text: 'Support us and get 30% OFF',
    key: 'productHunt'
  }, */
  // {
  //   icon: <MaterialIcon name='thumb_up_alt' variant='label-default' style={{ fontSize: '32px' }} />,
  //   title: 'Leave Feedback',
  //   text: 'Help us make FinalBit even better!',
  //   key: 'feedback'
  // },
  /* {
    icon: <img alt='Annapolis' src={AnnapolisLogo} style={{ width: 60, objectFit: 'cover' }} />,
    title: 'FinalBit x Annapolis Film Fest',
    text: 'Supporting the next wave of storytellers! 🎬',
    key: 'annapolisFilmFest',
    btnText: 'Read more'
  }, */
  /* {
    icon: <MaterialIcon name='local_activity' variant='label-default' style={{ fontSize: '32px' }} />,
    title: 'AI Box Office Prediction',
    text: 'Predict ROI Before You Greenlight.',
    key: 'predictBoxOffice',
    btnText: 'Try now'
  }, */
  {
    icon: <MaterialIcon name='discount' variant='label-default' style={{ fontSize: '32px' }} />,
    title: 'You’re Missing Powerful Tools',
    text: 'Get full access to breakdowns, advanced scheduling, and scene generation',
    key: 'pricing',
    trackingKey: 'static_banner',
    btnText: 'Unlock More'
  },
  /* {
    icon: <img alt='Sora2' src={Sora2} />,
    title: 'Sora 2 is here!',
    text: 'Now in the FinalBit Video Editor.',
    key: 'sora2',
    btnText: 'Try now'
  }, */
  {
    icon: <MaterialIcon name='smart_display' variant='label-default' style={{ fontSize: '32px' }} />,
    title: 'Follow Us on YouTube!',
    text: 'Watch exclusive filmmaker interviews & behind-the-scenes insights.',
    key: 'youtubeRed',
    btnText: '🔔 Subscribe Now'
  }
  /* {
    icon: <MaterialIcon name='discount' variant='label-default' style={{ fontSize: '32px' }} />,
    title: 'Claim your 50% discount!',
    text: 'Check your email for the discount link',
    key: 'claimDiscount'
  }, */
  /* {
    icon: <DiscordIcon />,
    title: 'Join us on Discord!',
    text: ' Check out our Discord page to be a part of the FinalBit community',
    key: 'discord',
    btnText: 'Join Group'
  } *//* {
    icon: <MaterialIcon name='lock_open' variant='label-default' style={{ fontSize: '32px' }} />,
    title: 'Upgrade to Our Pro Plan for Enhanced Writing!',
    text: 'Unlock Plot Hole Detection and Seamless Co-writing',
    key: 'pricing'
  } */
]

const myScriptEmpty = {
  title: 'Start Your First Script',
  text: 'Once you set up your first script, all your work in progress will appear here',
  icon: <ScriptEmptyIcon />

}

const mySharedEmpty = {
  title: 'Invite Co-Authors',
  text: 'Now you can invite colleagues and collaborate with them on a script in real time!',
  icon: <ScriptShareEmptyIcon />

}

const ScriptMenuItems = [
  {
    title: 'Move to project',
    key: 'moveScript',
    icon: <MaterialIcon name='drive_folder_upload' style={{ fontSize: 16 }} />
  },
  {
    title: 'Start Editing',
    key: 'editing',
    icon: <EditIcon />
  },
  {
    title: 'Edit Script Title',
    key: 'titleEdit',
    icon: <RenameIcon />
  },
  {
    title: 'Screen Breakdown',
    key: 'breakdown',
    icon: <BreakDown />
  },
  {
    title: 'Plot Hole Reporting',
    key: 'plotHole',
    icon: <MaterialIcon name='troubleshoot' style={{ fontSize: 16 }} />
  },
  {
    title: 'Script Coverage Report',
    key: 'scriptCoverage',
    icon: <MaterialIcon name='newspaper' style={{ fontSize: 16 }} />
  },
  {
    title: 'Budgeting',
    key: 'budgeting-forecast',
    id: 'budgeting-forecast',
    icon: <MaterialIcon name='savings' style={{ fontSize: '20px' }} />,
    feature: 'budgeting'
  },
  {
    title: 'Storyboard',
    key: 'storyboard',
    icon: <MaterialIcon name='developer_board' style={{ fontSize: '20px' }} />
  },
  {
    title: 'Scheduling',
    key: 'scheduling',
    icon: <MaterialIcon name='schedule' style={{ fontSize: '20px' }} />
  },
  {
    title: 'Deck Builder',
    key: 'pitch-deck',
    id: 'pitch-deck',
    icon: <MaterialIcon name='movie_filter' style={{ fontSize: '20px' }} />,
    feature: 'pitch-deck'
  },
  {
    title: 'Delete Script',
    key: 'delete',
    icon: <DeleteIcon />
  }
]

const DemoMenuItems = [
  {
    title: 'Start Editing',
    key: 'editing',
    icon: <EditIcon />
  },
  {
    title: 'Screen Breakdown',
    key: 'breakdown',
    icon: <BreakDown />
  }
]

const plotHoleTypes = {
  narrative: 'Narrative',
  logical: 'Logical',
  character: 'Character'
}

const plotHoleStatuses = {
  empty: {
    text: 'Empty',
    color: '#000'
  },
  pending: {
    text: 'Pending',
    color: '#000'
  },
  in_progress: {
    text: 'In Progress',
    color: '#000'
  },
  failed: {
    text: 'Failed, please regenerate',
    color: '#a8071a'
  },
  success: {
    text: 'Completed',
    color: '#000'
  },
  canceled: {
    text: 'Canceled',
    color: '#a8071a'
  }
}

const deleteScriptModal = {
  text: 'Are you sure you want delete current script? This action cannot be undone!'
}

const SceneMenuItems = [
  {
    title: 'Add scene before',
    key: 'addingSceneBefore',
    icon: <MaterialIcon name='vertical_align_top' style={{ fontSize: 20 }} />
  },
  {
    title: 'Add scene after',
    key: 'addingSceneAfter',
    icon: <MaterialIcon name='vertical_align_bottom' style={{ fontSize: 20 }} />
  },
  /* {
    title: 'Start Editing',
    key: 'editing',
    icon: <EditIcon />
  }, */
  {
    title: 'Delete scene',
    key: 'delete',
    icon: <DeleteIcon />
  }
]

const CommentMenuItems = [

  {
    title: 'Resolve',
    key: 'resolve',
    icon: <MaterialIcon name='check' style={{ fontSize: 20 }} />
  },
  {
    title: 'Delete',
    key: 'delete',
    icon: <DeleteIcon />
  }
]

const EditorHeaderMenu = [
  {
    title: 'Screenplay',
    key: 'screenplay',
    id: 'editor',
    icon: <MaterialIcon name='drive_file_rename_outline' style={{ fontSize: '18px' }} />,
    feature: 'screen_play'
  },
  {
    title: 'Breakdown',
    key: 'breakdown',
    id: 'break-smart',
    icon: <MaterialIcon name='list_alt' style={{ fontSize: '18px' }} />,
    feature: 'break_smart'
  },
  {
    title: 'Scheduling',
    key: 'scheduling',
    id: 'scheduling',
    icon: <MaterialIcon name='schedule' style={{ fontSize: '20px' }} />,
    feature: 'scheduling'
  },
  {
    title: 'Budgeting',
    key: 'budgeting-forecast',
    id: 'budgeting-forecast',
    icon: <MaterialIcon name='savings' style={{ fontSize: '20px' }} />,
    feature: 'budgeting'
  },
  {
    title: 'Storyboard',
    key: 'storyboard',
    id: 'storyboard',
    icon: <MaterialIcon name='image' style={{ fontSize: '20px' }} />,
    feature: 'storyboard'
  },
  {
    title: 'Shot List',
    key: 'shot-list',
    id: 'shot-list',
    icon: <MaterialIcon name='camera_roll' style={{ fontSize: '20px' }} />,
    feature: 'shot-list'
  },
  {
    title: 'AI Video',
    key: 'video-editor',
    id: 'video-editor',
    icon: <MaterialIcon name='movie_filter' style={{ fontSize: '20px' }} />,
    feature: 'video-editor'
  },
  {
    title: 'Deck',
    key: 'pitch-deck',
    id: 'pitch-deck',
    icon: <MaterialIcon name='co_present' style={{ fontSize: '20px' }} />,
    feature: 'pitch-deck'
  },
  {
    title: 'Reports',
    key: 'reports',
    id: 'reports',
    icon: <MaterialIcon name='insights' style={{ fontSize: '20px' }} />,
    children: [
      {
        title: 'Plot Hole',
        key: 'plotHoleReport',
        id: 'plot-hole-report',
        icon: <MaterialIcon name='troubleshoot' style={{ fontSize: '20px' }} />
      },
      {
        title: 'Script Coverage',
        key: 'scriptCoverageReport',
        id: 'script-coverage',
        icon: <MaterialIcon name='newspaper' style={{ fontSize: '20px' }} />
      }
    ]
  }
]

const ProjectFeaturesList = [
  {
    title: 'Screenplay',
    key: 'screenplay',
    id: 'editor',
    icon: <MaterialIcon name='drive_file_rename_outline' style={{ fontSize: '18px' }} />,
    feature: 'screen_play'
  },
  {
    title: 'Breakdown',
    key: 'breakdown',
    id: 'breakdown',
    icon: <MaterialIcon name='list_alt' style={{ fontSize: '18px' }} />,
    feature: 'break_smart'
  },
  {
    title: 'Scheduling',
    key: 'scheduling',
    id: 'scheduling',
    icon: <MaterialIcon name='schedule' style={{ fontSize: '20px' }} />,
    feature: 'scheduling'
  },
  {
    title: 'Budgeting',
    key: 'budgeting-forecast',
    id: 'budgeting-forecast',
    icon: <MaterialIcon name='savings' outlined style={{ fontSize: '20px' }} />,
    feature: 'budgeting'
  },
  {
    title: 'Shot List',
    key: 'shot-list',
    id: 'shot-list',
    icon: <MaterialIcon name='camera' outlined style={{ fontSize: '20px' }} />,
    feature: 'shot-list'
  },
  {
    title: 'AI Video',
    key: 'video-editor',
    id: 'video-editor',
    icon: <MaterialIcon name='movie_filter' outlined style={{ fontSize: '20px' }} />,
    feature: 'video-editor'
  },
  {
    title: 'Storyboard',
    key: 'storyboard',
    id: 'storyboard',
    icon: <MaterialIcon name='image' outlined style={{ fontSize: '20px' }} />,
    feature: 'storyboard'
  },
  {
    title: 'Deck',
    key: 'pitch-deck',
    id: 'pitch-deck',
    icon: <MaterialIcon name='co_present' outlined style={{ fontSize: '20px' }} />,
    feature: 'pitch-deck'
  },
  {
    title: 'Reports',
    key: 'reports',
    id: 'reports',
    icon: <MaterialIcon name='insights' style={{ fontSize: '20px' }} />,
    children: [
      {
        title: 'Plot Hole',
        key: 'plot-hole-report',
        id: 'plot-hole-report',
        icon: <MaterialIcon name='troubleshoot' style={{ fontSize: '20px' }} />
      },
      {
        title: 'Script Coverage',
        key: 'script-coverage',
        id: 'script-coverage',
        icon: <MaterialIcon name='newspaper' style={{ fontSize: '20px' }} />
      }
    ]
  }
]

const EditorHeaderLeftMenuItems = [
  {
    title: 'Title Page',
    key: 'title',
    icon: <RenameIcon />,
    feature: 'title'
  },
  {
    title: 'Edit Synopsis',
    key: 'synopsis',
    icon: <TitleSheetIcon />,
    feature: 'synopsis'
  },
  {
    title: 'Find',
    key: 'findAndReplace',
    icon: <MaterialIcon name='find_replace' style={{ fontSize: 20 }} />,
    feature: 'findAndReplace'
  }
]

const EditorMainMenuItems = [
  {
    title: 'Save',
    key: 'save',
    icon: <MaterialIcon variant='selected' outlined name='save' style={{ fontSize: 20 }} />,
    feature: 'save'
  },
  {
    title: 'Export',
    key: 'download',
    icon: <MaterialIcon variant='selected' outlined name='file_download' style={{ fontSize: 20 }} />,
    feature: 'download'
  },
  {
    title: 'History',
    key: 'history',
    icon: <MaterialIcon variant='selected' name='history' style={{ fontSize: 20 }} />,
    feature: 'history'
  },
  {
    title: 'Comments',
    key: 'comments',
    icon: <MaterialIcon variant='selected' outlined name='comment' style={{ fontSize: 19, marginTop: 2 }} />,
    feature: 'download'
  },
  {
    key: 'divider'
  },
  {
    title: 'Co Pilot',
    key: 'coPilot',
    icon: <MaterialIcon variant='selected' outlined name='tips_and_updates' style={{ fontSize: 20 }} />,
    feature: 'aiRequestsHistory'
  },
  {
    title: 'Script Doctor',
    key: 'smartFormatting',
    icon: <MaterialIcon variant='selected' outlined name='medical_services' style={{ fontSize: 19 }} />,
    feature: 'script_smart',
    trackAs: 'script_doctor',
    analyticsFeature: 'scriptDoctor'
  }
]

const MobileEditorMainMenuItems = [
  {
    title: 'Co-Pilot',
    key: 'coPilot',
    icon: <MaterialIcon variant='selected' outlined name='tips_and_updates' style={{ fontSize: 20 }} />,
    feature: 'aiRequestsHistory'
  },
  {
    title: 'History',
    key: 'history',
    icon: <HistoryIcon />,
    feature: 'history'
  },
  {
    title: 'Comments',
    key: 'comments',
    icon: <CommentsIcons />,
    feature: 'download'
  },
  {
    title: 'Save',
    key: 'save',
    icon: <MaterialIcon variant='selected' name='save' style={{ fontSize: 20 }} />,
    feature: 'save'
  },
  {
    title: 'Export',
    key: 'download',
    icon: <MaterialIcon variant='selected' outlined name='file_download' style={{ fontSize: 20 }} />,
    feature: 'download'
  }
]

const BreakDownMainMenuItems = [
  {
    title: 'Export',
    key: 'download',
    icon: <MaterialIcon variant='selected' name='file_download' style={{ fontSize: 22 }} />,
    feature: 'download'
  },
  {
    title: 'Summary',
    key: 'breakdownSummary',
    icon: <MaterialIcon name='summarize' variant='selected' style={{ fontSize: '22px' }} />
  },
  {
    title: 'Run full script department breakdown...',
    label: 'Breakdown All Scenes...',
    key: 'automaticScriptBreakdown',
    icon: <MaterialIcon name='smart_button' variant='selected' style={{ fontSize: 24 }} />
  },
  {
    title: 'Scene Details',
    key: 'sceneDetails',
    icon: <MaterialIcon name='info' outlined variant='selected' style={{ fontSize: '22px' }} />
  },
  {
    title: 'Scene Notes',
    key: 'sceneNotes',
    icon: <MaterialIcon name='sticky_note_2' variant='selected' style={{ fontSize: 22 }} />
  },
  {
    title: "Extract this scene's elements",
    key: 'extractSceneElements',
    icon: <MaterialIcon name='style' variant='selected' style={{ fontSize: '22px' }} />
  },
  {
    title: 'Show Elements',
    key: 'triggerSceneElements',
    id: 'showSceneElement',
    icon: <MaterialIcon name='menu' variant='selected' style={{ fontSize: '22px' }} />
  },
  {
    title: 'Hide Elements',
    key: 'triggerSceneElements',
    id: 'hideSceneElement',
    icon: <MaterialIcon name='menu_open' variant='selected' style={{ fontSize: '22px' }} />
  }
]

const BreakDownSummaryMenuItems = [
  {
    title: 'Export',
    key: 'download',
    icon: <MaterialIcon variant='selected' name='file_download' style={{ fontSize: 20 }} />,
    feature: 'download'
  },
  {
    title: 'Show Elements',
    key: 'triggerSceneElements',
    id: 'showSceneElement',
    icon: <MaterialIcon name='menu' variant='selected' style={{ fontSize: '22px' }} />
  },
  {
    title: 'Hide Elements',
    key: 'triggerSceneElements',
    id: 'hideSceneElement',
    icon: <MaterialIcon name='menu_open' variant='selected' style={{ fontSize: '22px' }} />
  }
]

const SchedulingMainMenuItems = [
  {
    title: 'History',
    key: 'triggerHistory',
    id: 'triggerHistory',
    icon: <MaterialIcon name='history' variant='selected' style={{ fontSize: '20px' }} />
  },
  {
    title: 'Show Cast List',
    key: 'triggerCastMembers',
    id: 'showCastMembers',
    icon: <MaterialIcon name='group' variant='selected' style={{ fontSize: '20px' }} />
  },
  {
    title: 'Hide Cast List',
    key: 'triggerCastMembers',
    id: 'hideCastMembers',
    icon: <MaterialIcon name='group' variant='selected' style={{ fontSize: '20px' }} />
  }
]

const BudgetingMainMenuItems = [
  {
    title: 'History',
    key: 'triggerHistory',
    id: 'triggerHistory',
    icon: <MaterialIcon name='history' variant='selected' style={{ fontSize: '20px' }} />
  }
]

const URLS = [
  '/',
  '/terms-of-service',
  '/privacy-policy',
  '/about-us',
  '/blog',
  '/blog/[slug]'
]

const SCRIPT_TYPES = {
  videoShort: {
    title: 'Video Short',
    icon: <MaterialIcon outlined name='smart_screen' />
  },
  featureFilm: {
    title: 'Feature Film',
    icon: <MaterialIcon outlined name='movie' />
  },
  episodicPilot: {
    title: 'Episodic Pilot',
    icon: <MaterialIcon outlined name='tv' />
  },
  tvShow: {
    title: 'TV Show',
    icon: <MaterialIcon outlined name='tv' />
  },
  socialMedia: {
    title: 'Social Media',
    icon: <MaterialIcon outlined name='smart_screen' />
  }
}

const FILM_PALLETS = [
  {
    name: 'Pastel Dreams',
    colors: ['Soft Pink', 'Custard Yellow', "Robin's Egg Blue", 'Pistachio Green', 'Warm Salmon'],
    colorCodes: ['#F3D1D4', '#FFDB58', '#96DED1', '#93C572', '#FF8C69']
  },
  {
    name: 'Digital Vibes',
    colors: ['Bright Green', 'Deep Black', 'Muted Gray', 'Rain Forest', 'Dark Charcoal'],
    colorCodes: ['#00FF41', '#000000', '#1B1B1B', '#0D3F11', '#0D0208']
  },
  {
    name: 'Urban Noir',
    colors: ['Neon Pink', 'Electric Blue', 'Rich Purple', 'Golden Amber', 'Charcoal Black'],
    colorCodes: ['#FF00FF', '#0000FF', '#301934', '#FFB700', '#101010']
  },
  {
    name: 'Golden Twilight',
    colors: ['Golden Yellow', 'Dusky Purple', 'Deep Blue', 'Coral Pink', 'Burnt Orange'],
    colorCodes: ['#FEBA4F', '#8B4B8B', '#191970', '#FF7F50', '#FD5E53']
  },
  {
    name: 'Regal Elegance',
    colors: ['Blush Pink', 'Royal Purple', 'Ruby Red', 'Bright Gold', 'Deep Blue'],
    colorCodes: ['#FFB7C5', '#7851A9', '#E0115F', '#FFD700', '#4169E1']
  },
  {
    name: 'Desert Glow',
    colors: ['Rust Orange', 'Earth Brown', 'Sand Beige', 'Metallic Silver', 'Crimson Red'],
    colorCodes: ['#B7410E', '#964B00', '#EDC9AF', '#C4C4C4', '#880808']
  },
  {
    name: 'French Romance',
    colors: ['Crimson Red', 'Forest Green', 'Rich Gold', 'Bright Yellow', 'Ocean Blue'],
    colorCodes: ['#FF1E1E', '#4B6F44', '#FFD700', '#FFE135', '#1E4C6B']
  },
  {
    name: 'Ocean Serenity',
    colors: ['Aqua Blue', 'Teal Green', 'Silver Mist', 'Dark Purple', 'Sand White'],
    colorCodes: ['#0087BD', '#008080', '#C0C0C0', '#2A0134', '#FFF5E1']
  },
  {
    name: 'Vivid Contrast',
    colors: ['Bright Yellow', 'Deep Black', 'Blood Red', 'Snow White', 'Burnt Orange'],
    colorCodes: ['#FFF01F', '#000000', '#BB0A1E', '#FFFFFF', '#FD6A02']
  },
  {
    name: 'Neon Nights',
    colors: ['Hot Pink', 'Deep Blue', 'Vivid Purple', 'Bright Red', 'Pure White'],
    colorCodes: ['#FF00FF', '#0000FF', '#301934', '#FF0000', '#FFFFFF']
  },
  {
    name: 'Modern Tech',
    colors: ['Bright Red', 'Soft White', 'Warm Pink', 'Bold Blue', 'Neutral Gray'],
    colorCodes: ['#FF4040', '#FAFAFA', '#FFB6C1', '#4169E1', '#808080']
  },
  {
    name: 'Cosmic Space',
    colors: ['Vivid Red', 'Bright White', 'Deep Black', 'Silver Star', 'Cosmos Blue'],
    colorCodes: ['#FF0000', '#FFFFFF', '#000000', '#C0C0C0', '#191970']
  },
  {
    name: 'Gothic Shadows',
    colors: ['Dark Black', 'Pale White', 'Plum Purple', 'Steel Gray', 'Rich Red'],
    colorCodes: ['#000000', '#F8F8FF', '#2F0743', '#C0C0C0', '#8B0000']
  },
  {
    name: 'Soft Palette',
    colors: ['Blush Pink', 'Cream Beige', 'Sky Blue', 'Gold Sparkle', 'Pure White'],
    colorCodes: ['#FFB6C1', '#FFFDD0', '#B0C4DE', '#FFD700', '#FBFBFB']
  },
  {
    name: 'Dark Elegance',
    colors: ['Jet Black', 'Navy Blue', 'Emerald Green', 'Golden Yellow', 'Ash Gray'],
    colorCodes: ['#000000', '#000080', '#4CBB17', '#FFD700', '#808080']
  },
  {
    name: 'Monochrome Drama',
    colors: ['Pure Black', 'Bright White', 'Bold Red', 'Soft Silver', 'Muted Gray'],
    colorCodes: ['#000000', '#FFFFFF', '#FF0000', '#C0C0C0', '#696969']
  },
  {
    name: 'Lush Nature',
    colors: ['Deep Blue', 'Lush Green', 'Mystic Purple', 'Cyan Glow', 'Bright White'],
    colorCodes: ['#4B0082', '#228B22', '#800080', '#00FFFF', '#F8F8FF']
  },
  {
    name: 'Bold Contrast',
    colors: ['Jet Black', 'Bright Red', 'Sunshine Yellow', 'Earth Brown', 'Steel Silver'],
    colorCodes: ['#000000', '#FF0000', '#FFF01F', '#8B4513', '#C0C0C0']
  },
  {
    name: 'Oceanic Dreams',
    colors: ['Tiger Orange', 'Turquoise Blue', 'Storm Navy', 'Golden Yellow', 'Deep Sea Blue'],
    colorCodes: ['#FFA500', '#40E0D0', '#000080', '#FFD700', '#000080']
  },
  {
    name: 'Dreamy Pastel',
    colors: ['Soft Orange', 'Sky Blue', 'Sunny Yellow', 'Clementine Red', 'Bright White'],
    colorCodes: ['#FFA500', '#1E90FF', '#FFE87C', '#FF4500', '#FFFFFF']
  },
  {
    name: 'Emotional Drama',
    colors: ['Deep Crimson', 'Stormy Gray', 'Ash Blue', 'Burnt Orange', 'Muted Gold'],
    colorCodes: ['#A52A2A', '#696969', '#6A5ACD', '#FF8C00', '#D4AF37']
  },
  {
    name: 'Dark Thriller',
    colors: ['Midnight Black', 'Blood Red', 'Mystic Purple', 'Steel Gray', 'Fog White'],
    colorCodes: ['#000000', '#8B0000', '#4B0082', '#B0C4DE', '#F5F5F5']
  },
  {
    name: 'Wholesome Family',
    colors: ['Warm Yellow', 'Soft Blue', 'Gentle Green', 'Peach Pink', 'Cream White'],
    colorCodes: ['#FFD700', '#87CEEB', '#98FB98', '#FFDAB9', '#FFFDD0']
  }
]

const MOOD = [
  'Dark',
  'Mysterious',
  'Brooding',
  'Cynical',
  'Shadowy',
  'Rebellious',
  'Romantic',
  'Philosophical',
  'Youthful',
  'Experimental',
  'Glamorous',
  'Dramatic',
  'Larger-than-life',
  'Optimistic',
  'Raw',
  'Authentic',
  'Melancholic',
  'Human',
  'Truthful',
  'Dystopian',
  'Tech-noir',
  'Alienated',
  'Gritty',
  'Distorted',
  'Psychological',
  'Anxious',
  'Dreamlike',
  'Intense',
  'Whimsical',
  'Enchanted',
  'Poetic',
  'Surreal',
  'Eerie',
  'Suspenseful',
  'Haunting',
  'Disturbing',
  'Atmospheric',
  'Intimate',
  'Natural',
  'Understated',
  'Genuine',
  'Slice-of-life',
  'Epic',
  'Adventurous',
  'Wonder',
  'Heroic',
  'Spectacular',
  'Rugged',
  'Lawless',
  'Moral',
  'Frontier spirit',
  'Contemplative',
  'Abstract',
  'Profound',
  'Personal',
  'Artistic',
  'Exotic',
  'Sensual',
  'Carefree',
  'Vibrant',
  'Desolate',
  'Survival',
  'Harsh',
  'Primitive',
  'Desperate',
  'Grandiose',
  'Emotional',
  'Sweeping',
  'Majestic',
  'Powerful',
  'Energetic',
  'Fresh',
  'Street-smart',
  'Contemporary',
  'Sentimental',
  'Warm',
  'Innocent',
  'Dreamy',
  'Retro',
  'Enchanting',
  'Thoughtful',
  'Magical',
  'Tense',
  'Paranoid',
  'Political',
  'Secretive',
  'Strategic',
  'Clean',
  'Precise',
  'Sophisticated',
  'Controlled',
  'Elegant'
]

export {
  BannerItems,
  myScriptEmpty,
  mySharedEmpty,
  plotHoleTypes,
  plotHoleStatuses,
  DemoMenuItems,
  ScriptMenuItems,
  deleteScriptModal,
  SceneMenuItems,
  EditorHeaderMenu,
  MobileEditorMainMenuItems,
  EditorHeaderLeftMenuItems,
  EditorMainMenuItems,
  BreakDownMainMenuItems,
  URLS,
  CommentMenuItems,
  SchedulingMainMenuItems,
  BudgetingMainMenuItems,
  BreakDownSummaryMenuItems,
  ProjectFeaturesList,
  SCRIPT_TYPES,
  FILM_PALLETS,
  MOOD
}
